/**
 * Lo que contestaron las personas, de todas las campañas del comercio (`/activa/emails/respuestas`), con un selector
 * de campaña. Se contesta desde la casilla (Snov o el mail del comercio): acá se lee.
 */

import { emailsApi } from "../api";
import type { ListaCampanas } from "../types";
import { usePedido } from "../hooks/usePedido";
import { useEstadoEmails } from "../contexto";
import { ListaRespuestas } from "../components/ListaRespuestas";

export default function RespuestasEmailsPage() {
  const { version } = useEstadoEmails();
  const campanas = usePedido<ListaCampanas>(() => emailsApi.campanas(), "campanas", { refresco: version });
  return (
    <div className="space-y-5">
      <header>
        <h2 className="text-xl md:text-2xl font-bold text-slate-900 tracking-tight">Respuestas</h2>
        <p className="text-sm text-slate-500 mt-1">Lo que contestaron a tus mails. Se contesta desde la casilla que mandó la campaña.</p>
      </header>
      <ListaRespuestas campanas={(campanas.dato?.filas || []).filter((c) => (c.conteos?.respondieron || 0) > 0)} />
    </div>
  );
}
